import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=65c6e426&scoped=true&"
import script from "./GoodsList.vue?vue&type=script&lang=js&"
export * from "./GoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6e426",
  null
  
)

export default component.exports